import type { ProjectImportDestinationKind } from "../projectImportStore";
import { ProjectImportDestinationPicker } from "./ProjectImportDestinationPicker";
import { CommandPanel } from "./ui/command";

interface CommandPaletteEmptyProjectPanelProps {
  readonly allowedDestinations: readonly ProjectImportDestinationKind[];
  readonly onSelectDestination: (destination: ProjectImportDestinationKind) => void;
  readonly selectedDestination: ProjectImportDestinationKind;
}

/**
 * The "blank project" step of Add Project. Pulled out of
 * `OpenCommandPaletteDialog` (apps/web/src/components/CommandPalette.tsx) —
 * the boundary took the whole `isEmptyProjectView` `CommandPanel` branch, and
 * every value it reads was already computed by the caller before the branch,
 * so no closures moved.
 */
export function CommandPaletteEmptyProjectPanel({
  allowedDestinations,
  onSelectDestination,
  selectedDestination,
}: CommandPaletteEmptyProjectPanelProps) {
  return (
    <CommandPanel className="min-h-[160px] max-h-[min(28rem,70vh)] rounded-b-none">
      <ProjectImportDestinationPicker
        allowedDestinations={allowedDestinations}
        label="Create in"
        onSelect={onSelectDestination}
        selectedDestination={selectedDestination}
      />
      <div className="px-5 py-5">
        <p className="text-xs font-medium tracking-[0.08em] text-muted-foreground/60 uppercase">
          Blank Project
        </p>
        <p className="mt-2 text-sm text-muted-foreground">
          Enter a name above, then press Enter to create.
        </p>
      </div>
    </CommandPanel>
  );
}
